var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("ivu-minible-menu-" + _vm.theme)},[_vm._t("logo"),_c(_vm.shrink ? 'SiderMini' : 'SiderBar',{tag:"component",on:{"on-select":_vm.handleSelect}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }